import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const sessionMatch = hash.match(/session_id=([^&]+)/);
    if (!sessionMatch) {
      navigate("/login");
      return;
    }
    const session_id = sessionMatch[1];
    (async () => {
      try {
        await api.post("/auth/google/session", { session_id });
        await refreshUser();
        // clear the hash for security
        window.history.replaceState(null, "", "/app");
        navigate("/app", { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, refreshUser]);

  return (
    <div className="min-h-screen bg-[#F8F7F3] flex items-center justify-center text-[#5B5B62] font-mono text-xs uppercase tracking-widest">
      Establishing secure session…
    </div>
  );
}
